import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import { Range, getTrackBackground } from 'react-range'
import history from '../../../history'
import { isMobile } from 'react-device-detect'

import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../../NavigationBar/NavigationBar'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../../GenericComponents/GenericSwitch'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericInput from '../../../GenericComponents/GenericInput'
import GenericRange from '../../../GenericComponents/GenericRange'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericMobileTopNavigation from '../../../GenericComponents/GenericMobileTopNavigation'

import AppContext from '../../../context/appContext'
import changeLocation from '../../../utils/changeLocalization'

import {
  getUserData,
  setUserBmr,
  removeUserBmr,
  getUserBmr,
} from '../../../Api/backendApi'
import { patchDiet } from '../../../Api/dietApi/userInfo'
import Navigation from '../../Challenges/components/Navigation/Navigation'

import WorkIcon from '../../../assets/REDESIGN_Assets/Calculator/work-icon.svg'
import TrainingIcon from '../../../assets/REDESIGN_Assets/Calculator/training-icon.svg'

import {
  InputRow,
  RangeNumbers,
  CalculatorStepContainer,
  ActivityBox,
  UserGoalButtonBox,
  UserGoalOption,
  ResultColumn,
} from '../style/CalculatorStyles'

interface CalculatorViewInterface {
  creationDietMode: boolean,
  challengeMode: boolean
}

const CalculatorView: FC<CalculatorViewInterface> = ({ creationDietMode, challengeMode }) => {
  const appContext = useContext(AppContext)
  const [user, setUser] = useState(Object)
  const [weight, setWeight] = useState(0)
  const [height, setHeight] = useState(0)
  const [age, setAge] = useState(0)
  const [userActivity, setUserActivity] = useState([3])
  const [userGoal, setUserGoal] = useState(1)
  const [calculatorStep, setCalculatorStep] = useState(0)
  const [bmrResult, setBrmResult] = useState(0)
  const [cpmResult, setCpmResult] = useState(0)
  const [protein, setProtein] = useState({ weight: 0, kcal: 0 })
  const [carbo, setCarbo] = useState({ weight: 0, kcal: 0 })
  const [fat, setFat] = useState({ weight: 0, kcal: 0 })
  const [userKcalNeed, setUserKcalNeed] = useState(0)

  useEffect(() => {
    obtainUserBmr()
    obtainUser()
  }, [])

  // const goBackToMainpage = () => {
  //   history.push('/trening')
  // }

  const activityText = [
    'Brak aktywności',
    'Niska aktywność',
    'Średnia aktywność',
    'Wysoka aktywność',
    'Bardzo wysoka aktywność',
  ]
  const workText = [
    'Praca siedząca',
    'Praca siedząca',
    'Praca siedząca',
    'Praca fizyczna',
    'Zawodowi sportowcy',
  ]
  const trainingText = [
    'Max 1 trening w tygodniu',
    '1-2 treningi w tygodniu',
    '3-4 treningi w tygodniu',
    '3-4 treningi w tygodniu',
    'Codzienne treningi',
  ]

  const goalText = ['', 'schudnąć', 'utrzymać wagę', 'przybrać na wadze']

  const obtainUserBmr = async () => {
    const userBrmr = await getUserBmr()
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await getUserData()

    setUser(user)
    appContext.updateAppState('user', user)
  }

  const handleObtainDataStepOne = (mode: string, value: number) => {
    switch (mode) {
      case 'weight':
        setWeight(value)
        break
      case 'height':
        setHeight(value)
        break
      case 'age':
        setAge(value)
        break
      default:
        break
    }
  }

  const handleChangeUserGoal = (e: any) => {
    setUserGoal(parseInt(e.target.id))

    if (e.target.classList.contains('active')) {
      return
    } else {
      const allElements = Array.from(
        document.getElementsByClassName('goal-option')
      )

      allElements &&
        allElements.forEach((element: any) => {
          element.classList.contains('active') &&
            element.id !== e.target.id &&
            element.classList.remove('active')
        })
      e.target.classList.add('active')
    }
  }

  const handleProgressCalculatorStep = () => {
    switch (calculatorStep) {
      case 0:
        if (weight < 30 || weight === null) {
          notify.show(`Podaj poprawną wagę`, 'error', 3000)
          return
        }

        if (height < 100 || height === null) {
          notify.show(`Podaj poprawną wartość wzrostu`, 'error', 3000)
          return
        }
        if (age < 10 || age === null) {
          notify.show(`Podaj poprawny wiek`, 'error', 3000)
          return
        }

        setCalculatorStep(calculatorStep + 1)

        break

      case 1:
        if (userGoal == null) {
          notify.show(`Proszę wybierz plan treningu`, 'error', 3000)
          return
        } else {
          calculateBMR()
          setCalculatorStep(calculatorStep + 1)
          return
        }
        break

      case 2:
        saveBmr()
        break
      default:
        break
    }
  }

  const calculateBMR = () => {
    const bmrResult = 9.99 * weight + 6.25 * height - 4.92 * age - 161
    let cpmResult = 0

    setBrmResult(bmrResult)

    // Calculate percentage of proteins, fat and carbo
    // protein
    const proteinKcal = bmrResult * 0.15
    const proteinWeight = proteinKcal / 4.02
    setProtein({ kcal: proteinKcal, weight: proteinWeight })
    // carbo
    const carboKcal = bmrResult * 0.55
    const carboWeight = carboKcal / 4.02
    setCarbo({ kcal: carboKcal, weight: carboWeight })
    // fat
    const fatKcal = bmrResult * 0.3
    const fatWeight = fatKcal / 9
    setFat({ kcal: fatKcal, weight: fatWeight })

    switch (userActivity[0]) {
      case 1:
        cpmResult = bmrResult * 1.2
        setCpmResult(cpmResult)
        break
      case 2:
        cpmResult = bmrResult * 1.35
        setCpmResult(cpmResult)
        break
      case 3:
        cpmResult = bmrResult * 1.55
        setCpmResult(cpmResult)
        break
      case 4:
        cpmResult = bmrResult * 1.75
        setCpmResult(cpmResult)
        break
      case 5:
        cpmResult = bmrResult * 2.05
        setCpmResult(cpmResult)
        break
      default:
        break
    }

    switch (userGoal) {
      case 1:
        setUserKcalNeed(Math.floor(cpmResult - 200))
        break
      case 2:
        setUserKcalNeed(Math.floor(cpmResult))
        break
      case 3:
        setUserKcalNeed(Math.floor(cpmResult + 250))
        break
      default:
        break
    }
  }

  const saveBmr = async () => {
    if (creationDietMode) {
      await patchDiet(
        Math.floor(userKcalNeed),
        Math.floor(protein.weight),
        Math.floor(carbo.weight),
        Math.floor(fat.weight)
      )

      setTimeout(() => {
        history.push({ pathname: '/dieta', state: { challengeMode: challengeMode } })
      }, 1000)
    } else {
      setUserBmr(weight, height, age, userActivity[0], userGoal)
      setTimeout(() => {
        history.push({ pathname: '/twoj-profil', state: { challengeMode: challengeMode } })
      }, 1000)
    }
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
        }`}
    >
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={null}
          handleClick={() => history.push('/twoj-profil')}
        />
      )}
      {challengeMode ? <Navigation /> : <NavigationBar
        isPlayerView={false}
        backButtonAction={() => changeLocation('/trening')}
      />}
      <GenericMainCard
        margin={'5% auto 0 auto'}
        maxWidth={'1000px'}
        className="standard"
        width={isMobile ? '95%' : '60%'}
        flexDir="column"
      >
        <GenericTextSpan fSize={'1.6rem'} margin={'0 0 5% 0'}>
          Oblicz swoje zapotrzebowanie kaloryczne (BMR)
        </GenericTextSpan>
        {calculatorStep == 0 ? (
          <>
            <InputRow>
              <GenericTextSpan fSize={''}>Waga</GenericTextSpan>
              <GenericInput
                onChange={(e: any) =>
                  handleObtainDataStepOne('weight', e.target.value)
                }
                maxWidth={isMobile ? '75%' : '50%'}
                autoFocus
                fSize={isMobile ? '2.3rem' : '3rem'}
                className={'no-border color-white text-center'}
                type="number"
                max={1000}
                min={0}
                placeholder={'--'}
              ></GenericInput>
              <GenericTextSpan fSize={''}>kg</GenericTextSpan>
            </InputRow>

            <InputRow>
              <GenericTextSpan fSize={''}>Wzrost</GenericTextSpan>
              <GenericInput
                onChange={(e: any) =>
                  handleObtainDataStepOne('height', e.target.value)
                }
                maxWidth={isMobile ? '75%' : '50%'}
                fSize={isMobile ? '2.3rem' : '3rem'}
                className={'no-border color-white text-center'}
                type="number"
                max={1000}
                min={0}
                placeholder={'---'}
              ></GenericInput>
              <GenericTextSpan fSize={''}>cm</GenericTextSpan>
            </InputRow>

            <InputRow>
              <GenericTextSpan fSize={''}>Wiek</GenericTextSpan>
              <GenericInput
                onChange={(e: any) =>
                  handleObtainDataStepOne('age', e.target.value)
                }
                maxWidth={isMobile ? '75%' : '50%'}
                fSize={isMobile ? '2.3rem' : '3rem'}
                className={'no-border color-white text-center'}
                type="number"
                max={1000}
                min={0}
                placeholder={'--'}
              ></GenericInput>
              <GenericTextSpan fSize={''}>lat</GenericTextSpan>
            </InputRow>
          </>
        ) : calculatorStep == 1 ? (
          <CalculatorStepContainer width={isMobile ? '90%' : '50%'}>
            <GenericTextSpan fSize={'1.1rem'} margin={'1% 0 6% 0'}>
              Jaka jest twoja aktywność fizyczna?
            </GenericTextSpan>
            <GenericRange
              allSteps={userActivity}
              onChange={setUserActivity}
              startStep={1}
              minStep={1}
              maxStep={5}
              showOutput={false}
            />
            <RangeNumbers>
              <GenericTextSpan>1</GenericTextSpan>
              <GenericTextSpan>2</GenericTextSpan>
              <GenericTextSpan>3</GenericTextSpan>
              <GenericTextSpan>4</GenericTextSpan>
              <GenericTextSpan>5</GenericTextSpan>
            </RangeNumbers>

            <ActivityBox>
              <GenericTextSpan
                margin={'0 0 3% 0'}
                fWeight={'bold'}
                fSize={'1.2rem'}
                width={'100%'}
                display={'block'}
                tAlign={'left'}
              >
                {activityText[userActivity[0] - 1]}
              </GenericTextSpan>
              <GenericRow justify={'start'}>
                <GenericIcon
                  src={WorkIcon}
                  width={isMobile ? '3.5vw' : '1.1vw'}
                  height={isMobile ? '3.5vw' : '1.1vw'}
                />
                <GenericTextSpan margin={'2% 0 2% 5%'}>
                  {workText[userActivity[0] - 1]}
                </GenericTextSpan>
              </GenericRow>

              <GenericRow justify={'start'}>
                <GenericIcon
                  src={TrainingIcon}
                  width={isMobile ? '3.5vw' : '1.1vw'}
                  height={isMobile ? '3.5vw' : '1.1vw'}
                />
                <GenericTextSpan margin={'2% 0 2% 5%'}>
                  {trainingText[userActivity[0] - 1]}
                </GenericTextSpan>
              </GenericRow>
            </ActivityBox>
            <GenericTextSpan margin={'7% 0'}>Co planujesz</GenericTextSpan>
            <UserGoalButtonBox>
              <UserGoalOption
                className={'goal-option active'}
                onClick={(e: any) => handleChangeUserGoal(e)}
                id={1}
              >
                Schudnąć
              </UserGoalOption>
              <UserGoalOption
                className={'goal-option'}
                onClick={(e: any) => handleChangeUserGoal(e)}
                id={2}
              >
                Utrzymać
              </UserGoalOption>
              <UserGoalOption
                className={'goal-option'}
                onClick={(e: any) => handleChangeUserGoal(e)}
                id={3}
              >
                Przytyć
              </UserGoalOption>
            </UserGoalButtonBox>
          </CalculatorStepContainer>
        ) : (
          <CalculatorStepContainer width={isMobile ? '95%' : '70%'}>
            <ActivityBox marginTop={'0'}>
              <GenericTextSpan margin={'2% 0'} fSize={'1.1rem'}>
                Aby {goalText[userGoal]}, uwzględniając Twoje całkowite
                zapotrzebowanie kaloryczne, dostarcz organizmowi*:
              </GenericTextSpan>
              <GenericRow margin={'2% 0'}>
                <GenericTextSpan
                  className={'color-green '}
                  margin={'0 10px 0 0'}
                  fSize={'4.5rem'}
                >
                  {userKcalNeed}
                </GenericTextSpan>
                <GenericTextSpan>kcal</GenericTextSpan>
              </GenericRow>

              <GenericRow justify={'space-around'} align={'flex-start'}>
                <ResultColumn>
                  <GenericTextSpan
                    margin={'0px 0 10px 0'}
                    fWeight={'bold'}
                    fSize={'1.3rem'}
                  >
                    Białko
                  </GenericTextSpan>
                  <GenericTextSpan
                    className={'color-green'}
                    margin={'0px 0 10px 0'}
                    fSize={'1.6rem'}
                  >
                    15%
                  </GenericTextSpan>
                  <GenericTextSpan margin={'0px 0 10px 0'}>
                    {Math.floor(protein.kcal)} kcal
                  </GenericTextSpan>
                  <GenericTextSpan margin={'0px 0 10px 0'}>
                    {Math.floor(protein.weight)}g
                  </GenericTextSpan>
                </ResultColumn>

                <ResultColumn>
                  <GenericTextSpan
                    margin={'0px 0 10px 0'}
                    fWeight={'bold'}
                    fSize={'1.3rem'}
                  >
                    Węglowodany
                  </GenericTextSpan>
                  <GenericTextSpan
                    className={'color-green'}
                    fSize={'1.6rem'}
                    margin={'0px 0 10px 0'}
                  >
                    55%
                  </GenericTextSpan>
                  <GenericTextSpan margin={'0px 0 10px 0'}>
                    {Math.floor(carbo.kcal)} kcal
                  </GenericTextSpan>
                  <GenericTextSpan margin={'0px 0 10px 0'}>
                    {Math.floor(carbo.weight)}g
                  </GenericTextSpan>
                </ResultColumn>
                <ResultColumn>
                  <GenericTextSpan
                    margin={'0px 0 10px 0'}
                    fWeight={'bold'}
                    fSize={'1.3rem'}
                  >
                    Tłuszcz
                  </GenericTextSpan>
                  <GenericTextSpan
                    className={'color-green'}
                    margin={'0px 0 10px 0'}
                    fSize={'1.6rem'}
                  >
                    30%
                  </GenericTextSpan>
                  <GenericTextSpan margin={'0px 0 10px 0'}>
                    {Math.floor(fat.kcal)} kcal
                  </GenericTextSpan>
                  <GenericTextSpan margin={'0px 0 10px 0'}>
                    {' '}
                    {Math.floor(fat.weight)}g
                  </GenericTextSpan>
                </ResultColumn>
              </GenericRow>
            </ActivityBox>
          </CalculatorStepContainer>
        )}
        {calculatorStep == 2 && (
          <GenericTextSpan width={'60%'} margin={'3% 0 10px 0'}>
            * Są to orientacyjne wyliczenia, które mogą różnić się u
            poszczególnych osób ze względu na indywidualne cechy i parametry
            dodatkowe.
          </GenericTextSpan>
        )}
        <GenericButton
          width={isMobile ? '90%' : '40%'}
          justify={'center'}
          margin={'5% 0 3% 0'}
          className={'standard with-arrow'}
          onClick={() => handleProgressCalculatorStep()}
        >
          {calculatorStep == 0 || calculatorStep == 1
            ? 'Przejdź dalej'
            : 'Zapisz'}
        </GenericButton>
      </GenericMainCard>
      {/* <GenericLogo margin={'3% auto'} /> */}
    </GenericBackgroundLayer>
  )
}

export default CalculatorView
